/**
 * MultiAccordion class
 *
 * Handles images for single accordions inside its multi-image container.
 */
class MultiAccordion {
	/**
	 * Constructor.
	 *
	 * @param {HTMLElement} container The multi-accordion wrapper element.
	 */
	constructor( container ) {
		this.container = container;
		this.imageWrap = container.querySelector( '.multi-image-accordions__image-wrap' );
		this.images = Array.from( container.querySelectorAll( '.accordion-image-placeholder img' ) );
		this.defaultImage = this.imageWrap.querySelector( '[data-accordion-image-type="default"]' );
		this.containerId = container.dataset.multiAccordionId;

		// Move and hide all placeholder images.
		this.prepareImages();
		// Listen for accordion toggle events.
		wp.hooks.addAction( 'qalaBlocks.accordionToggle', 'qala-blocks', this.onAccordionToggle );
	}

	/**
	 * Move all placeholder images into the shared imageWrap and hide them.
	 */
	prepareImages() {
		const imageWrap = this.imageWrap;
		this.images.forEach( image => {
			image.classList.add( 'multi-accordion-image-hidden' );
			imageWrap.appendChild( image );
		} );
	}

	/**
	 * Handles the accordionToggle hook.
	 *
	 * @param {string} imageId The image ID to be shown.
	 * @param {string} containerId The container ID of the multi-accordion.
	 * @param {boolean} openState Whether the accordion was opened.
	 */
	onAccordionToggle = ( imageId, containerId, openState ) => {
		//check if the incoming containerId from the single accordion matches the current container.
		if ( containerId !== this.containerId ) {
			return;
		}
		// Only handle the event if the image is part of this multi-accordion.
		const image = this.images.find( img => img.dataset.imageId === imageId );
		if ( ! image ) {
			return;
		}

		// Hide all other images.
		this.images.forEach( img => img.classList.add( 'multi-accordion-image-hidden' ) );

		if ( openState ) {
			image.classList.remove( 'multi-accordion-image-hidden' );
			if ( this.defaultImage ) {
				this.defaultImage.classList.add( 'multi-accordion-image-hidden' );
			}
		} else if ( this.defaultImage ) {
			this.defaultImage.classList.remove( 'multi-accordion-image-hidden' );
		}

		// Notify single accordions to close others.
		wp.hooks.doAction( 'qalaBlocks.singleAccordionOpened', imageId, containerId );
	}
}

// Init all multi-accordions on the page.
document.querySelectorAll( '.wp-block-qala-blocks-multi-image-accordions' ).forEach( container => {
	new MultiAccordion( container );
} );
